import { FormControl, FormField, FormItem } from "../ui/form";
import type { FieldValues, Path, UseFormReturn } from "react-hook-form";
import { Slider } from "../ui/slider";

type FormRangeProps<T extends FieldValues> = {
	form: UseFormReturn<T>;
	name: Path<T>;
	min?: number;
	max: number;
	onValueChange?: (value: number) => void;
	className?: string;
};

export const FormRange = <T extends FieldValues>({
	form,
	name,
	min = 1,
	max,
	onValueChange,
	className,
}: FormRangeProps<T>) => {
	return (
		<FormField
			control={form.control}
			name={name}
			render={({ field }) => (
				<FormItem>
					<FormControl>
						<Slider
							stepsVisible={true}
							overLabelVisible={true}
							value={[Number.parseInt(field.value?.toString() || "0")]}
							onValueChange={(values) => {
								const newValue = Number.parseInt(values[0].toString());
								field.onChange(newValue);
								if (onValueChange) {
									onValueChange(newValue);
								}
							}}
							max={max}
							min={min}
							step={max / 20}
							className={className}
						/>
					</FormControl>
				</FormItem>
			)}
		/>
	);
};
